var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeStarGold4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M32.4933 31.2656C30.4977 35.2049 28.4009 38.9817 26.468 42.1183C24.5352 45.255 22.8532 47.6106 21.6348 48.8873C20.4163 50.1639 19.7162 50.3042 19.6229 49.2904C19.5296 48.2767 20.0473 46.1544 21.1106 43.192C22.1739 40.2295 23.735 36.5601 25.5964 32.6477C27.4579 28.7354 29.536 24.7558 31.5681 21.2124C33.6001 17.669 35.4948 14.7209 37.0124 12.7411C38.53 10.7612 39.6024 9.83845 40.094 10.0895C40.4209 10.2551 40.4835 10.9343 40.2784 12.0882C40.0733 13.2421 39.6045 14.8482 38.8986 16.8147C38.1928 18.7812 37.2638 21.0696 36.1648 23.5491C35.0657 26.0286 33.8181 28.6507 32.4933 31.2656Z",
    fill: "url(#paint0_radial_1585_73654)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M31.2649 27.5153C35.2041 29.5109 38.9809 31.6077 42.1176 33.5405C45.2543 35.4733 47.6099 37.1553 48.8865 38.3738C50.1632 39.5922 50.3035 40.2923 49.2897 40.3856C48.2759 40.4789 46.1536 39.9612 43.1912 38.8979C40.2288 37.8346 36.5594 36.2735 32.647 34.4121C28.7346 32.5507 24.7551 30.4725 21.2117 28.4405C17.6683 26.4084 14.7202 24.5138 12.7403 22.9962C10.7605 21.4785 9.83772 20.4061 10.0888 19.9146C10.2544 19.5877 10.9336 19.525 12.0875 19.7301C13.2414 19.9352 14.8475 20.4041 16.814 21.1099C18.7805 21.8157 21.0689 22.7447 23.5484 23.8438C26.0279 24.9428 28.65 26.1904 31.2649 27.5153Z",
    fill: "url(#paint1_radial_1585_73654)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M30.5805 32.7349C26.2599 33.6474 22.0025 34.3793 18.3468 34.8379C14.6912 35.2966 11.8014 35.4614 10.043 35.3115C8.28458 35.1616 7.73658 34.7038 8.46828 33.996C9.19998 33.2881 11.1785 32.3621 14.1536 31.3349C17.1288 30.3077 20.9668 29.2255 25.1824 28.2252C29.398 27.225 33.8017 26.3515 37.8365 25.7154C41.8714 25.0793 45.3562 24.709 47.8501 24.6515C50.3441 24.594 51.7352 24.8517 51.8474 25.3922C51.9231 25.7507 51.4331 26.2251 50.4052 26.7881C49.3773 27.3512 47.8317 27.992 45.8568 28.6739C43.8819 29.3557 41.5162 30.0653 38.8951 30.7621C36.274 31.4589 33.4486 32.1293 30.5805 32.7349Z",
    fill: "url(#paint2_radial_1585_73654)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M32.7344 29.4278C33.6469 33.7484 34.3788 38.0058 34.8374 41.6615C35.2961 45.3172 35.4609 48.2069 35.311 49.9653C35.1612 51.7237 34.7033 52.2717 33.9955 51.54C33.2877 50.8083 32.3616 48.8298 31.3344 45.8547C30.3072 42.8796 29.225 39.0415 28.2247 34.8259C27.2245 30.6103 26.351 26.2066 25.7149 22.1718C25.0788 18.1369 24.7086 14.6521 24.651 12.1582C24.5935 9.66421 24.8513 8.27314 25.3917 8.16088C25.7502 8.08516 26.2246 8.57524 26.7876 9.60313C27.3507 10.631 27.9915 12.1766 28.6734 14.1515C29.3552 16.1264 30.0648 18.4921 30.7616 21.1132C31.4584 23.7344 32.1288 26.5597 32.7344 29.4278Z",
    fill: "url(#paint3_radial_1585_73654)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1585_73654",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0039 30.0045) rotate(26.8666) scale(2.79065 22.3252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFF7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFEDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFDF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A05B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#754200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#512E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#331D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0C0700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1585_73654",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0037 30.0047) rotate(-63.1334) scale(2.79065 22.3252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFF7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFEDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFDF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A05B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#754200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#512E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#331D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0C0700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1585_73654",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0038 30.0045) rotate(78.0742) scale(2.79065 22.3252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFF7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFEDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFDF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A05B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#754200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#512E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#331D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0C0700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1585_73654",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.004 30.0045) rotate(-11.9258) scale(2.79065 22.3252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFF7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFEDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFDF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A05B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#754200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#512E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#331D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1D1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0C0700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStarGold4);
export default __webpack_public_path__ + "static/media/Home_Star_Gold_4.baf541a7dcd711b2ed4b6b7239caa07b.svg";
export { ForwardRef as ReactComponent };